import { useState } from 'react';
import { Tag, Button } from 'antd';
import { MdEdit, MdDelete } from 'react-icons/md';
import { ConfirmationModal } from '@/components/confirmationModal';
import { ConfirmationTypeEnum } from '@/types';
import { ICategory } from '../../../types/categorySetup';

interface CategoryCardProps {
  category: ICategory;
  onEdit: (category: ICategory) => void;
  onDelete: (categoryId: string) => void;
}

export const CategoryCard = ({ category, onEdit, onDelete }: CategoryCardProps) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = () => {
    onDelete(category.dogma_categoryid);
    setShowDeleteModal(false);
  };

  return (
    <div className="bg-white border border-neutral-400 rounded-lg p-4">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-text-primary mb-1">
            {category.dogma_name}
          </h3>
          {category.dogma_description && (
            <p className="text-sm text-text-secondary mb-2">
              {category.dogma_description}
            </p>
          )}
          <Tag className="mt-2">
            {category['dogma_categorytype@OData.Community.Display.V1.FormattedValue']}
          </Tag>
          <p className="text-xs text-text-secondary mt-2">
            {category.dogma_optionscount || 0} options
          </p>
        </div>
        <div className="flex gap-1">
          <Button
            type="text"
            size="middle"
            icon={<MdEdit size={18} />}
            onClick={() => onEdit(category)}
          />
          <Button
            type="text"
            size="middle"
            icon={<MdDelete size={18} />}
            onClick={handleDeleteClick}
            danger
          />
        </div>
      </div>

      <ConfirmationModal
        open={showDeleteModal}
        type={ConfirmationTypeEnum.danger}
        title="Delete Category"
        content={`Are you sure you want to delete "${category.dogma_name}"? This action cannot be undone.`}
        cancelBtnText="Cancel"
        okBtnText="Delete"
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
      />
    </div>
  );
};
